<input
  type="checkbox"
  [attr.aria-required]="to.required"
  [attr.required]="to.required"
  [formControl]="formControl"
  [formlyAttributes]="field"
>
